import type IEngagementSummary from "@components/pricing/zipPricing/zipWidget/interfaces/IEngagementSummary";
import { findElement } from "./directiveHelpers";
import type { BeforeMountDefinition } from "./DirectiveDefinition";
import { MountedDefinition } from "./DirectiveDefinition";
import { fetchData } from "@utility/webServices";
import type { IActionResponse } from "@interfaces/response/IActionResponse";

const registerLeadGenEvent: BeforeMountDefinition = {
  beforeMount(el, binding, vnode, prevVnode) {
    findElement(el).addEventListener(binding.arg, () => sendLeadGenEvent(binding));
  },
};

const sendLeadGenEvent = (binding: any) => {
  const leadGenEvent = binding?.value();
  if (!leadGenEvent) {
    return;
  }
  const events = Array.isArray(leadGenEvent) ? leadGenEvent : [leadGenEvent];
  for (const event of events) {
    // Assuming ga.SendLeadGenEvent is a function that handles the event
    sendInteraction(event);
  }
};

const sendInteraction = async (interaction: IEngagementSummary) => {
  const response = (await fetchData<IActionResponse>("", interaction)) ?? {
    Successful: false,
    Message: "There was an error syncing the interaction.",
  };
  return response;
};

export { registerLeadGenEvent };
